import axios from "axios";

const http = axios.create({
	baseURL: import.meta.env.VUE_APP_API_BASE_URL + "api/admin",
});

export function setAuthToken(token) {
	if (token) {
		http.defaults.headers.common.Authorization = "Bearer " + token;
	} else {
		delete http.defaults.headers.common.Authorization;
	}
}

http.interceptors.response.use(response => {
	const method = response.config.method?.toLowerCase();
	if (["post", "put", "patch", "delete"].includes(method)
		&& (/^(offer|placement|advertiser)\//.test(response.config.url || "")
			|| ["notification/reviewAction", "notification/delete", "user/saveProfile"].includes(response.config.url))
		&& response.data?.err === 0) {
		window.dispatchEvent(new Event("octava:attention-changed"));
	}
	return response;
});

export default http;
